import React, { useEffect } from 'react';
import { IMPORT_VISIBILITY as articleVisibility } from '@nile/rmm/src/modules/knowledge-base/helper/constants';
import { RadioButton, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import TechGroupShareFilter from '@nile/rmm/src/modules/knowledge-base/components/TechGroupShareFilter';
import { getCurrentUserHook } from '@nile/components';

const values = {
  ALL: {
    portalType: 'TECHNICIAN',
    userSharedType: 'AllUsers',
    groupSharedType: 'AllGroups'
  },
  ONLY_ME: {
    portalType: 'TECHNICIAN',
    userSharedType: 'User',
    groupSharedType: 'AllGroups'
  },
  SPECIFIC: {
    portalType: 'TECHNICIAN',
    userSharedType: 'AllUsers',
    groupSharedType: 'Group'
  }
};
function ImportVisibility({ visibility, setVisibility }) {
  const [checked, setChecked] = React.useState(null);
  const currentUser = getCurrentUserHook();
  const handleChoiceChange = (val, radioChange) => {
    if (radioChange) {
      setChecked(val);
      if (val === 'ALL') {
        setVisibility({ ...values[val], sharedType: val });
      } else if (val === 'ONLY_ME') {
        setVisibility({
          ...values[val],
          sharedType: val,
          addedUserIds: [currentUser?.userId]
        });
      } else {
        setVisibility({ ...values[val], sharedType: val, groups: [] });
      }
    } else {
      setVisibility({ ...val, portalType: visibility?.portalType });
    }
  };

  useEffect(() => {
    setChecked(visibility?.sharedType);
  }, [visibility]);

  return (
    <div className="flex fcol scroll">
      {articleVisibility.map((item) => (
        <div className="flex fcol g5">
          <RadioButton
            checked={checked === item?.key}
            label={
              <div className="flex fcol g5">
                <TextStyle weight="Medium">
                  <FormattedMessage id={item?.label} />
                </TextStyle>
                {item?.description && (
                  <TextStyle variation="subdued">
                    <FormattedMessage id={item?.description} />
                  </TextStyle>
                )}
              </div>
            }
            onChange={() => handleChoiceChange(item?.key, true)}
          />
          {item?.key === 'SPECIFIC' && (
            <div className="ml-30">
              <TechGroupShareFilter
                data={visibility}
                mappingKey={visibility?.portalType}
                updateData={(val, key) => handleChoiceChange(val, false)}
                disabled={checked !== item?.key}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default ImportVisibility;
